module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_gearlounge.b69f66ac2f9d9f6ad718aa9701a99dc2.png";